import type { ComponentType } from "react";

/**
 * Code-split seam for the Claude Code for Kids detail page — the exact
 * pattern established by design-workshop-detail-loader.ts (read that file's
 * header for the full SSR/hydration rationale). Short version:
 *
 * - SERVER: routes-ssr.tsx imports the page eagerly and registers it here,
 *   so renderToString emits full SSR content for /workshops/claude-code-for-kids.
 * - CLIENT: the page ships as its own chunk. entry-client.tsx awaits the
 *   preload before hydrateRoot when the dehydrated state contains the kids
 *   event, so first client render matches the server tree exactly.
 * - Client-side navigation: the gate inside event-detail.tsx loads the chunk
 *   on demand behind the standard skeleton.
 */

let KidsDetail: ComponentType | null = null;

export function getKidsDetail(): ComponentType | null {
  return KidsDetail;
}

/** Called by routes-ssr.tsx (server bundle only) with the eager import. */
export function setKidsDetail(component: ComponentType): void {
  KidsDetail = component;
}

let pending: Promise<ComponentType> | null = null;

export function preloadKidsDetail(): Promise<ComponentType> {
  if (KidsDetail) return Promise.resolve(KidsDetail);
  if (!pending) {
    pending = import("@/pages/claude-kids-detail").then((m) => {
      KidsDetail = m.default;
      return m.default;
    });
    // Allow a retry if the chunk fails to load (matches the design-workshop
    // loader) — otherwise one transient network failure is cached forever.
    pending.catch(() => {
      pending = null;
    });
  }
  return pending;
}
